import defineReadAutoAction from '~/prix/actions/defineReadAutoAction'
import macroRegionReadAction from './macroRegionRead.action.json' with { type: 'json' }

const macroRegionReadDefinition = defineReadAutoAction(macroRegionReadAction, 'macroRegion')

export default macroRegionReadDefinition
